import React from "react";
import translate from "../../../reusable/translate";

const ReportTextContainer = React.forwardRef(
  ({ textKey, reportText, setReportText }, textContainerRef) => {
    return (
      <div>
        <p className="p">
          <b>{translate({ textKey: textKey })}</b>
        </p>
        <textarea
          ref={textContainerRef}
          value={reportText}
          className="text-area"
          rows="10"
          placeholder={translate({
            textKey: "sit.commitment.operationReport.writeReportInFinnish",
          })}
          onChange={(e) => setReportText(e.target.value)}
        />
      </div>
    );
  }
);

export default ReportTextContainer;



// WEBPACK FOOTER //
// ./src/components/profile/reports/components/ReportTextContainer.jsx